export const TERMS_VERSION = "1.0";

export const TERMS_SECTIONS = [
  {
    title: "1. Engagement & Role",
    body: "You are engaged by MoversNearby (JBRN GROUP PTY LTD) as an independent contractor in the role of Driver or Helper/Offsider as selected in your profile. You agree to perform removalist duties professionally, punctually and safely, and to follow all reasonable directions from the office and job leaders.",
  },
  {
    title: "2. Pay Hold Policy (1 Week)",
    body: "Your first week of pay will be held for one (1) week and released in the following pay cycle. This standing 1-week pay hold applies for the duration of your engagement and is settled in full upon proper completion of your notice period.",
  },
  {
    title: "3. Notice Period (15 Days)",
    body: "A minimum of fifteen (15) days written notice is required before ending your engagement. Failure to provide the full 15 days notice may result in forfeiture of held pay to cover replacement and rescheduling costs, to the extent permitted by law.",
  },
  {
    title: "4. Vehicle Damage & Insurance Excess",
    body: "Drivers are responsible for the safe operation of company vehicles. In the event of at-fault damage to a company vehicle, the applicable insurance excess is payable by the driver: drivers UNDER 25 years of age — up to $4,000 AUD; drivers OVER 25 years of age — up to $1,700 AUD. Any damage must be reported to the office immediately.",
  },
  {
    title: "5. Physical Fitness & Medical Liability Waiver",
    body: "Removalist work is physically demanding and regularly involves lifting items of 25kg or more (with team lifts and equipment where appropriate). By signing, you confirm you are physically fit to perform this work, have disclosed any relevant medical conditions, and release MoversNearby from liability for injury arising from a failure to disclose a pre-existing condition or from not following safe lifting procedures and training.",
  },
  {
    title: "6. Zero Tolerance — Drugs & Alcohol (0.00% BAC)",
    body: "MoversNearby operates a strict zero tolerance policy. You must have a 0.00% blood alcohol concentration and be free of illicit drugs at all times while on duty or operating any vehicle or equipment. Breach of this policy results in immediate termination and may be reported to relevant authorities.",
  },
  {
    title: "7. Equipment Care",
    body: "All equipment (trolleys, blankets, straps, tools, GPS devices and uniforms) must be cared for, kept clean and returned in good condition. Lost or negligently damaged equipment may be deducted from pay at replacement cost. Trucks must be kept clean and refuelled as directed.",
  },
  {
    title: "8. Conduct, Attendance & Customer Care / Property Damage",
    body:
      "You must treat customers, their property, and fellow crew members with respect at all times.\n\n" +
      "Job Attendance & No-Show Policy: Once a job is assigned and accepted, failure to attend the job without a valid reason or prior notification will result in a penalty fee of $200 AUD, which may be deducted from your earnings or held pay.\n\n" +
      "Property & Goods Damage Liability: Damage to customer property must be reported to the office immediately and never concealed. In the event of damage caused to customer property or goods during a job due to negligence, the contractor (Driver and/or Helper assigned) will be held responsible for the cost of repair/replacement, or for paying the applicable insurance excess/deductible, as determined by the company policy and insurance coverage. Accepting private/cash jobs from MoversNearby customers is strictly prohibited.",
  },
  {
    title: "9. Payroll & Bank Details",
    body: "Pay is calculated from signed-off job hours at your agreed hourly rate, plus applicable call-out amounts, and is paid to the nominated bank account in your profile. You are responsible for providing a valid ABN and managing your own superannuation and tax obligations as an independent contractor.",
  },
  {
    title: "10. Privacy & Data",
    body: "Your personal details, licence information, emergency contact and bank details are stored securely and used only for payroll, rostering, insurance and legal compliance. Your live location is shared with the office only while you are marked On My Way to a job.",
  },
];

export const KEY_CLAUSES = [
  "1 week pay hold policy",
  "15 days notice period required",
  "Vehicle damage excess: Under 25 — $4,000 / Over 25 — $1,700",
  "Physically fit for 25kg+ lifting (medical waiver)",
  "Zero tolerance drugs & alcohol (0.00% BAC)",
  "Equipment care & return in good condition",
  "No-show penalty $200; property/goods damage liability",
];
